import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=6ee127a2&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=6ee127a2&prod&scoped=true&lang=css"
import style1 from "./TwoFactor.vue?vue&type=style&index=1&id=6ee127a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee127a2",
  null
  
)

export default component.exports